import search from '../plugins/search'
import maps from '../plugins/maps'

document.addEventListener('turbolinks:load', function(){
  search.addClickListener(maps);
  maps.init(search);
})